export class TranscricaoOcrResult {
  key: string;
  idUnidade: Number;
  nomeUnidade: string;

  idMedico: Number;
  crm: string;
  nomeMedico: string;

  idPaciente: Number;
  nomePaciente: string;
  pesoPaciente: Number;

  registro: string;
  leito: string;
  divisaoBolsas: Number;
  volumeDesejado: Number;
  viaAdministracao: string;
  tempoInfusao:Number;
  pesoCalorico:Boolean;

  produtos: ProdutoOcrResult[];

  constructor() {
    
  }
}

export class ProdutoOcrResult {
  id: Number;
  codigo: string;
  nome: string;
  idUnidadeMedida: Number;
  nomeUnidadeMedida: string;
  quantidade: Number;
  nomeOriginal: string;
}

export class TranscricaoOcrParm {
  key: string;
  idUnidade: Number;
  idMedico: Number;
  idPaciente: Number;
}

export class TranscricaoOcrValidValorParm {
  key: string;
  campo: string;
  valor: string;
  aprovado: boolean;
}